import { useApi, useAuth } from '../../hooks';
import { useQuery } from '@tanstack/react-query';

type CareTeamMember = {
  bio: string | null
  display_name: string
  healthie_id: number
  image_url: string | null
  type: string
}

export const useUserCareTeam = (userId: string) => {
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const fetchUserCareTeam = async () => {
    const requestObj = {
      route: `/private/user/care-team/`,
      token: userToken,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Coach-Override': userId,
      }
    };

    return await api(requestObj);
  };

  const { data, isLoading, isError } = useQuery<CareTeamMember[], Error>({
    queryKey: ['hc-user-care-team', userToken, userId],
    queryFn: () => fetchUserCareTeam(),
    enabled: !!userId && isAuthenticated && !loading && !!userToken,
    refetchOnWindowFocus: false,
  });

  return { data, isLoading, isError };
};
